import RefetchState from 'redux/refetch/interfaces/refetchState';

const INIT_REFETCH_STATE: RefetchState = {
  beats: false,
};

export default INIT_REFETCH_STATE;
